import React from "react";
import Card from "../../../components/Card"
import Text from "../../../components/Text";
import cx from "classnames";
import styles from './SettingOverview.module.css'

const SettingCard: React.FC<{title: string, button: {title: string, action: () => void}, text: string}> = ({title, button, text}) => {
    return (
        <Card title={title} classes={cx(styles['setting-card'])} actions={[
            {title: button.title, onAction: button.action, type: 'secondary', classes: 'w-100 m-2'}
        ]}>
            <Text>{text}</Text>
        </Card>
    )
}

export default SettingCard
